export const castleConstants = {
  GET_REQUEST: 'CASTLE_GET_REQUEST',
  GET_SUCCESS: 'CASTLE_GET_SUCCESS',
  GET_FAILURE: 'CASTLE_GET_FAILURE',

  ADD_REQUEST: 'CASTLE_ADD_REQUEST',
  ADD_SUCCESS: 'CASTLE_ADD_SUCCESS',
  ADD_FAILURE: 'CASTLE_ADD_FAILURE',

  SUMMARY_REQUEST: 'CASTLE_GET_SUMMARY_REQUEST',
  SUMMARY_SUCCESS: 'CASTLE_GET_SUMMARY_SUCCESS',
  SUMMARY_FAILURE: 'CASTLE_GET_SUMMARY_FAILURE',
  UPDATE_TOOL_TIP: 'UPDATE_TOOL_TIP',
  }
